export default class SpinnerEvent extends CustomEvent {

    static show(pSpinnerId) {

        const spinnerEvent = new SpinnerEvent({
            cmd: "show",
            spinnerId: pSpinnerId
        })
        
        window.dispatchEvent(spinnerEvent)
    }

    static hide(pSpinnerId) {

        const spinnerEvent = new SpinnerEvent({
            cmd: "hide",
            spinnerId: pSpinnerId
        })
        
        window.dispatchEvent(spinnerEvent)
    }

    constructor(p) {

        super(
            "spinnerEvent",
            {
                detail: {
                    cmd: p.cmd,
                    id: p.spinnerId
                }
            }
        )
    }
}